import React, { useState, useEffect } from 'react'
import SBNav from '../../shared/components/SideBarNav/SBNav'
import styles from './login.module.scss'
import LoginForm from './LoginForm';
import SignupForm from './SignupForm';

const Login = () => {

    useEffect(() => {
        document.title = 'Login'
    }, [])

    const [nav, openNav] = useState(false);
    const [loginMode, setLoginMode] = useState<'login' | 'signup'>('login');



    useEffect(() => {
        if (!nav) {
            // ensure cleanup if nav is false
            document.documentElement.classList.remove("nav-blur");
            document.body.style.overflow = "";
            document.body.style.position = "";
            document.body.style.top = "";
            document.body.style.width = "";
            return;
        }


        // --- lock scroll (keeps current scroll position) ---
        const scrollY = window.scrollY;

        // add blur class to <html> (we'll define CSS below)
        document.documentElement.classList.add("nav-blur");

        // lock body in place
        document.body.style.overflow = "hidden";
        document.body.style.position = "fixed";
        document.body.style.top = `-${scrollY}px`;
        document.body.style.width = "100%";

        return () => {
            // --- restore ---
            document.documentElement.classList.remove("nav-blur");

            document.body.style.overflow = "";
            document.body.style.position = "";
            document.body.style.top = "";
            document.body.style.width = "";

            window.scrollTo(0, scrollY);
        };
    }, [nav]);

    const toggleModeClick = () => {
        setLoginMode(loginMode === 'login' ? 'signup' : 'login');
    }

    return (
        <div style={{ backgroundImage: `url('images/cbb2.png')` }} className={styles.login}>

            <div className='nav-2 nav-2-alt'>
                <div className='nav-logo-container'>
                    <img src='images/flashroom-logo-light.png' height="44px" />
                    <h1>Flash<span>Room</span></h1>
                </div>


                <div className='hamburger-menu-2' onClick={() => openNav(true)}>
                    <div />
                    <div />
                    <div />
                </div>

            </div>


            <div className={`nav-cont ${nav ? 'nav-open' : 'nav-closed'}`}>

                <div className='standard-xi-cont'

                    onClick={() => openNav(false)}
                >

                    <svg className="x-icon-sbn" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 111.01 111.01">
                        <g id="Layer_3" data-name="Layer 3">
                            <path
                                className="cls-1"
                                d="M232.21,289.66a10.1,10.1,0,0,1-14.31,0l-38.22-38.22-38.23,38.23a10.13,10.13,0,0,1-14.32-14.32l38.23-38.23L127.14,198.9a10.12,10.12,0,1,1,14.31-14.31l38.22,38.22,38.23-38.23a10.13,10.13,0,0,1,14.32,14.32L194,237.13l38.22,38.22A10.12,10.12,0,0,1,232.21,289.66Z"
                                transform="translate(-124.17 -181.62)"
                            />
                        </g>
                    </svg>

                </div>

                <SBNav />

            </div>

            <div className={styles.loginBody}>
                <div className={styles.loginFormContainer}>
                    <h2>{loginMode === 'login' ? 'Login' : 'Sign Up'}</h2>
                    {loginMode === 'login' ? <LoginForm /> : <SignupForm />}


                    <div style={{ height: '1rem' }} />


                    <p >{loginMode === "login" ? 'Don\'t have an account?' : 'Already have an account? '} <span onClick={toggleModeClick}>{loginMode === "login" ? 'Sign up' : 'Login'}</span></p>
                </div>


            </div>




        </div>
    )
}

export default Login
